const list = [
    {
        value: 2,
        name: '医生预约',
        type: 'button',
        icon: require("@/assets/images/my/my_list_2.png"),
    },
    {
        value: 3,
        name: '隐私政策',
        icon: require("@/assets/images/my/my_list_3.png"),
        pagePath: '/privacyPolicy?type=1'
    },
    {
        value: 4,
        name: '服务协议',
        icon: require("@/assets/images/my/my_list_4.png"),
        pagePath: '/privacyPolicy?type=2'
    }
]
const times = [
    {
        value: 1,
        name: '9:00~11点'
    },
    {
        value: 2,
        name: '9:00~11点'
    },
    {
        value: 3,
        name: '9:00~11点'
    },
    {
        value: 4,
        name: '9:00~11点'
    }
]
export default {
    list,
    times
}